import WideViewModal from "components/__new/common/WideViewModal";
import { Input, SelectInput } from "components/__new/common/form";
import React, { useEffect, useRef, useState, useMemo } from 'react';
import { TableContentCustom } from "components/__new/common/TableContent";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import validate from "utils/validate";
import * as employeesActions from "store/entities/employees/action";
import * as infoActions from "store/entities/settingsInfo/action";
import * as banksActions from "store/ui/banks/action";
import * as groupsActions from "store/entities/groups/action";
import * as payrollSetupActions from "store/entities/payroll/payrollSetup/action";
import ModalAlert from "components/__new/common/ModalAlert";
import { ReactComponent as PhoneNumberCodeIcon } from "assets/images/icons/Group 86.svg"
import { ReactComponent as CloseOutIcon } from "assets/images/icons/closeout.svg"
import { ButtonLoader } from "components/__new/common/form";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import Maybe from "components/__new/common/Maybe";
import { renderStatusColor } from "utils/statusColor";
import { ReactComponent as IconNav } from "assets/images/icons/DropdownDot.svg";
import { ReactComponent as ErrorAlertIcon } from "assets/images/icons/erroricon.svg";
import DropDown from "components/__new/employees/DropDown";
import { ReactComponent as IconEdit } from "assets/images/icons/project-icons/edit-pen.svg";
import { ReactComponent as AddIcon } from "assets/images/icons/add-01.svg";
import { ReactComponent as RedXIcon } from "assets/images/icons/x.svg";
import Spinner from 'components/__new/common/Spinner';
import { DateFullFormat } from "utils/dateFormat";
import { REGEX_VALUES } from 'utils/regexValues';
import useLoginInfo from 'hooks/useLoginInfo';
import ReactSelect from 'react-select';
import { reactSelectStyles } from 'utils/reactSelectStyles';



const tabs = [
  "Basic Information",
  "Work Information",
  "Bank Information",
  "Pension & tax Information"
]

 
 
 export const EmployeeInputModal = ({ setIsAddEmployeeOpen, isAddEmployeeOpen, getEmployees, banksLoading, banks }) => {
  const [activeTab, setActivetab] = useState(1);
  const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const { employeeCreateLoading, employeeCreateSuccess, employeeCreateStatus, employeeCreated } = useSelector((s) => s.entities.employees);
    // const { banksLoading, banks } = useSelector((s) => s.ui.banks);
    const { getAllGroupsLoading: groupsLoading, allGroups: groups } = useSelector((s) => s.entities.groups);
    const { pensionProvidersLoading, pensionProvidersData } = useSelector((s) => s.entities.payrollSetup);

    
    const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
      const [formErrors, setFormErrors] = useState({
          firstName: null,
          lastName: null,
          phoneNumber: null,
          email: null,
          jobTitle: null,
          staffId: null,
          payGroup: null,
          netMonthlySalary: null,
          grossAnnualPay: null,
          bankName: null,
          bankCode: null,
          bankAccountNumber: null,
          taxIdentificationNumber: null,
          pensionAdministrator: null,
          pensionNumber: null,
          pensionAdministratorCode: null
      });
      
      const defaultValues = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        jobTitle: "",
        staffId: "",
        payGroup: "",
        netMonthlySalary: "",
        grossAnnualPay: "",
        formattedNet: "",
        formattedGross: "",
        bankName: "",
        bankCode: "",
        bankAccountNumber: "",
        taxIdentificationNumber: "",
        pensionAdministrator: "",
        pensionNumber: "",
        pensionAdministratorCode: "",
      }
    
    const [selectedBank, setSelectedBank] = useState(null);
    const [form, setForm] = useState({
        ...defaultValues
    })
    
    // || !form.email || !form.jobTitle || !form.staffId || !form.payGroup || !form.netMonthlySalary || !form.grossAnnualPay
    // else if(activeTab === 4 && (!form.taxIdentificationNumber || !form.pensionAdministrator || !form.pensionNumber || !form.pensionAdministratorCode)){
    //   return true;
    // }
    
    const validateEmail = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
  };
    
    const isButtonDisabled = useMemo(() => {
      if(activeTab === 1 && (form.firstName.length < 2 || form.lastName.length < 2 || form.phoneNumber.length !== 11 )){
        return true;
      } else if(activeTab === 2 && (!validateEmail(form.email) || form.jobTitle.length < 2 || !form.netMonthlySalary)){
        return true;
      } else if(activeTab === 3 && (!form.bankCode || form.bankAccountNumber.length !== 10)){
        return true;
      } else {
        return false;
      }
    }, [form, activeTab])
    
        
    const banksData = useMemo(() => {
      return banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((singleBank) => ({
        label: singleBank?.bankName || singleBank?.institutionName,
        value: singleBank?.bankCode || singleBank?.institutionCode,
      })) || [];
    }, [banks])
    
    const handleNameChange = (e) => {
      const { name, value } = e.target;
      if ((name === "firstName" || name === "lastName") && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY.test(value) || value.length > 30)) {
        return;
      }
      setForm({...form, [name]: value})
    }
    
    const handleIdChange = (e) => {
      const { name, value } = e.target;
      if ((name === "staffId" ) && (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
        return;
      }
      setForm({...form, [name]: value})
    }

  
    const handlePhoneChange = (e) => {
      const { name, value } = e.target;
      if ((name === "phoneNumber" ) && (REGEX_VALUES.PHONE_NUMBER.test(value) )) {
        setFormErrors({
          ...formErrors,
          phoneNumber: "Phone number must be 11 digits",
      })
      } else {
        setFormErrors({
          ...formErrors,
          phoneNumber: null,
      })
      }
      if ((value.length !== 12) && (value >= 0)) {
          setForm({...form, phoneNumber: value})
      } 
  }
  
  const handleEmailChange = (e) => {
    const {name, value} = e.target;
    
    if((name === "email") && (validateEmail(value))) {
      setFormErrors({
        ...formErrors,
        email: null,
    })   
    } else {
      setFormErrors({
        ...formErrors,
        email: "Valid email address is required",
    })
    }
    setForm({...form, email: value})
  }
  
  
  
  const handleNetMonthlyChange = (e) => {
          const { name, value } = e.target;
          
          if (value === "0") return;
          const cleanedValue = value.replace(/[^\d.]/g, '');
          const [integerPart, decimalPart] = cleanedValue.split('.');
          const formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          let formattedKoboVal = formattedValue;
          if (decimalPart !== undefined) {
              formattedKoboVal += '.' + decimalPart.slice(0, 2);
          }
          // const { newAmount } = applyCharge(formattedKoboVal.replace(/,/g, ''));
          const newAmount  = Number(formattedKoboVal.replace(/,/g, ''));
          setForm({
              ...form,
              // [name]: formattedKoboVal,
              formattedNet: formattedKoboVal,
              netMonthlySalary: newAmount,
              
          });
}
  
  const handleGrossMonthlyChange = (e) => {
    const { name, value } = e.target;
          
    if (value === "0") return;
    const cleanedValue = value.replace(/[^\d.]/g, '');
    const [integerPart, decimalPart] = cleanedValue.split('.');
    const formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let formattedKoboVal = formattedValue;
    if (decimalPart !== undefined) {
        formattedKoboVal += '.' + decimalPart.slice(0, 2);
    }
    const newAmount  = Number(formattedKoboVal.replace(/,/g, ''));
    setForm({
        ...form,
        // [name]: formattedKoboVal,
        formattedGross: formattedKoboVal,
        grossAnnualPay: newAmount,
        
    });
}
  
  const handleBankAccountNumberChange = (val) => {
    if(REGEX_VALUES.NUMBERS_ONLY.test(val)){
      return;
    }
    if(val < 0){
        setForm({...form, bankAccountNumber: val * -1})
    }
    else if ((val.length !== 11) && (val >= 0)) {
            setForm({...form, bankAccountNumber: val})
    }
  
}

    const getBankName = () => {
        const bankData = banks;
        for (var i = 0; i < bankData?.length; i++){
            if ((bankData[i].bankCode || bankData[i].institutionCode) === form.bankCode){
                return (bankData[i].bankName || bankData[i].institutionName);
            }
        }
        return null;
    }


    const getPfaCode = () => {
        const selectedAdministrator = pensionProvidersData?.data?.find((item) => item?.name === form?.pensionAdministrator);
        if(selectedAdministrator) {
            return selectedAdministrator?.pfa_code;
        }
    }
    
    const removeEmptyFields = (obj) => {
      Object.keys(obj)?.forEach(key => obj[key] === "" && delete obj[key]);
      return obj;
  }


    const submitForm = async e => {
      e.preventDefault();
        if (activeTab < 4 ) {
          setActivetab((prevState => prevState + 1));
          return;
        }
        const {formattedNet, formattedGross, ...editedForm} = form
        const validateForm = {...editedForm};
        delete validateForm["resumedAt"];
        delete validateForm["pensionAdministrator"];
        delete validateForm["pensionNumber"];
        delete validateForm["taxIdentificationNumber"];
        delete validateForm["pensionAdministratorCode"];
        delete validateForm["staffId"];
        delete validateForm["grossAnnualPay"];
        delete validateForm["payGroup"];
        
        // delete validateForm["netMonthlySalary"];
        const errors = validate(validateForm);
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const bankName = getBankName();
            const pensionAdministratorCode = getPfaCode();
            const params = {...editedForm, bankName, pensionAdministratorCode};
            setForm(params);
            const payload = removeEmptyFields(params)
            setForm(payload);
            dispatch(employeesActions.createEmployee(payload));
        }
    }


    const resetForm = () => {
        setForm({
          ...defaultValues
        })
        setSelectedBank(null);
        setActivetab(1)
      }

    const handleCloseAddEmployeeModal = () => {
      resetForm();
      setIsAddEmployeeOpen((prevState) => !prevState);
    }

    useEffect(() => {
        dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
        dispatch(banksActions.getAllBanks());
        dispatch(groupsActions.getGroupsB2b());
        dispatch(groupsActions.getAllGroups());
        dispatch(payrollSetupActions.getPensionProviders());
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (employeeCreated?.status === "success"){
            setIsAddEmployeeOpen((prevState) => !prevState);
            toast.success(employeeCreated?.message);
            getEmployees();
            // setIsOpenModalAlert(true);
            resetForm();
            dispatch(employeesActions.resetEmployeeCreateSuccess());
                // (employeeCreateSuccess === true) && 
            // dispatch(employeesActions.resetEmployeeCreateSuccess());
            // if (!employeeCreateStatus?.jobId){
            //     // history.push("/employees");
            //     setIsOpenModalAlert(true);
            //     resetForm();
            // }
            
        }
        // eslint-disable-next-line
    }, [employeeCreated]);
    
    

  return (
    <WideViewModal isOpen={isAddEmployeeOpen}  wideViewControl={true} size={"md"} wideViewClassName="w-[60%]" setIsOpen={handleCloseAddEmployeeModal}>
          
    <ModalAlert
        successText="Employee added successfully"
        dismissText="Add Another Employee"
        isOpenModalAlert={isOpenModalAlert}
        setIsOpenModalAlert={setIsOpenModalAlert}
    />
    <div className="w-full h-full p-[32px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>Add Single Employee</div>
                <button type="button" onClick={handleCloseAddEmployeeModal}><CloseOutIcon /></button>
            </div>
      <form onSubmit={submitForm}>
        <div className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-2">
            {
                tabs.map((text, index) => {
                    return (
                        <div key={index}>
                            <div className={`w-full h-[0.6rem] border rounded-md ${activeTab > index ? 'bg-[#00535C]' : 'bg-[gainsboro]'}`}></div>
                            <div className={`py-2 ${activeTab > index ? 'text-[#374151]' : 'text-[#718096]'}`}>{text}</div>
                        </div>
                    )
                })
            }
        </div>
        {
          activeTab === 1 && ( 
            <div>
                <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                    <Input type="text" label="First Name" placeholder="Enter Employee First Name" required={true} name="firstName" value={form.firstName} onChange={handleNameChange} inputClass="capitalize" />
                    <Input type="text" label="Last Name" placeholder="Enter Employee Last Name" required={true} name="lastName" value={form.lastName} onChange={handleNameChange} inputClass="capitalize" />
                    <Input type="tel" autoComplete="off" leftIcon={<PhoneNumberCodeIcon />} leftIconClass="w-[50px] h-[16px] top-3 left-2" leftIconInputClass="pl-[5rem]" label="Phone Number" placeholder="Enter Employee Phone Number" required={true} name="phoneNumber" value={form.phoneNumber} onChange={handlePhoneChange} 
                    tagText={formErrors?.phoneNumber}
                    tagTextIsRed
                    />
                </div>
            </div>
          )
        }
        {
          activeTab === 2 && (
            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <Input type="email" label="Email Address" name="email" placeholder="Enter Employee Email Address" required={true} value={form.email} onChange={handleEmailChange} 
                tagText={formErrors?.email}
                tagTextIsRed
                />
                <Input type="text" label="Staff ID (optional)" placeholder="Enter Staff ID Number" name="staffId" value={form.staffId} onChange={handleIdChange} />
                <Input type="text" label="Role" placeholder="Enter Role" required={true} value={form.jobTitle} onChange={(e) => setForm({...form, jobTitle: e.target.value})} />
                <div>
                    {(groupsLoading === true) && 
                        <Input type="text" label="Employee Group (optional)" value="Loading groups..." disabled={true} />
                    }
                    {(groupsLoading === false) && 
                        <SelectInput label="Employee Group (optional)" value={form.payGroup} onChange={(e) => setForm({...form, payGroup: e.target.value})}>
                            <option value="">Select Group</option>
                            {/* <option value="general-group">General Group</option> */}
                            {groups?.data?.map(group => (
                                <option key={group.id} value={group.id}>{group.name}</option>
                            ))}
                        </SelectInput>
                    }
                </div>
                {/* formattedNet */}
                {/* name="netMonthlySalary" */}
                <div className="relative">
                  <Input type="text" name="formattedNet"  label="Net Monthly Salary" placeholder="Enter Amount" required={true} value={form.formattedNet} className="input-number !pl-7" onChange={handleNetMonthlyChange} />
                  <div className="absolute left-3 top-8">₦&nbsp;</div>
                </div>
                <div className="relative">
                  <Input type="text" name="formattedGross" label="Gross Monthly Salary (optional)" placeholder="Enter Amount" value={form.formattedGross} className="input-number !pl-7" onChange={handleGrossMonthlyChange} />
                  <div className="absolute left-3 top-8">₦&nbsp;</div>
                </div>
                {/* formattedGross */}
                {/* name="grossAnnualPay" */}
            </div>
          )
        }
        
        {
          activeTab === 3 && (
            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <div>
                    {/* {(banksLoading === true) && 
                        <Input type="text" label="Bank Name" required={true} value="Loading banks..." disabled={true} />
                    }
                    {(banksLoading === false) && 
                        <SelectInput label="Bank Name" required={true} value={form.bankCode} onChange={(e) => setForm({...form, bankCode: e.target.value})}>
                            <option value="">Select Bank</option>
                            {banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map(bank => (
                                <option key={bank?.bankId || bank?.id} value={bank?.bankCode || bank?.institutionCode}>{bank?.bankName || bank?.institutionName}</option>
                            ))}
                        </SelectInput>
                    } */}
                    <p className="text-sm mb-1">Bank Name <span className="form-input-required">*</span></p>
                    <ReactSelect
                        isDisabled={banksLoading}
                        isLoading={banksLoading}
                        isSearchable
                        defaultValue={selectedBank}
                        onChange={(selected) => {
                          setSelectedBank(selected)
                            setForm({
                                ...form, 
                                bankCode: selected.value,
                                bankName: selected.label
                            });
                        }}
                        options={banksData}
                        styles={reactSelectStyles}
                        placeholder={banksLoading ? "Fetching banks..." : "Select Bank"}
                        noOptionsMessage={() => "No Banks Found"}
                    />
                </div>
                <Input type="text" label="Account Number" placeholder="Enter Bank Account Number" min={0} required={true} value={form.bankAccountNumber} className="input-number" onChange={(e) => handleBankAccountNumberChange(e.target.value)} />
            </div>
          )
        }
        
        {
          activeTab === 4 && (
            
            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <div>
                    <SelectInput disabled={pensionProvidersLoading} label="Pension Provider (Optional)" required={false} value={form.pensionAdministrator || ""} onChange={(e) => setForm({...form, pensionAdministrator: e.target.value})}>
                        <option value="">{pensionProvidersLoading ? "Fetching providers..." : form?.pensionAdministrator?.length ? form?.pensionAdministrator : "Select Provider"}</option>
                        {pensionProvidersData?.data?.map((item) => (
                            <option key={item?.name} value={item?.name}>{item?.name}</option>
                        ))}
                    </SelectInput>
                </div>
                <Input type="text" label="PEN Number (Optional)" placeholder="Enter PEN Number" required={false} value={form.pensionNumber || ""} onChange={(e) => setForm({...form, pensionNumber: e.target.value})} />
                <Input type="number" label="Tax Number (Optional)" placeholder="Enter here" required={false} value={form.taxIdentificationNumber || ""} onChange={(e) => setForm({...form, taxIdentificationNumber: e.target.value})} />
            </div>
          )
        }
        
        <div className="mt-4 flex justify-end space-x-4">
          <button type="button" onClick={() => activeTab === 1 ? handleCloseAddEmployeeModal() : setActivetab((prevState => prevState - 1))} className="btn btn-transparent-primary">
              {activeTab > 1 && activeTab <= 4 ? "Back" : "Cancel"}
          </button>
          <ButtonLoader type="submit" loading={employeeCreateLoading} disabled={isButtonDisabled} className="btn btn-ep-primary">
              {activeTab < 4 ? "Next" : "Add Employee"}
          </ButtonLoader>
        </div>
      </form>
    </div>
     </WideViewModal>
  )
 }
 
 export const EmployeeViewDataModal = ({ setIsViewEmployeeOpen, isViewEmployeeOpen, employee, groups, isEditEmployeeOpen, setIsEditEmployeeOpen }) => {
  const [activeTab, setActivetab] = useState(1);
  


  return (
    <WideViewModal isOpen={isViewEmployeeOpen}  wideViewControl={true} size={"xl"} wideViewClassName="w-[70%]" dialogPanelClassName="h-max-full" setIsOpen={() => {}}>
      <div className="w-full p-[20px]">
              <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                  <div>View Employee Data</div>
                  <div onClick={() => {setIsViewEmployeeOpen(false); setActivetab(1)}}><CloseOutIcon /></div>
              </div>
        <div>
          <hr className="mb-2" />
        <button onClick={() => {
          setIsViewEmployeeOpen(false);
          setActivetab(1);
          setIsEditEmployeeOpen(true);
          }} className="flex w-full justify-end text-[#00535C] underline my-4"><IconEdit /> Edit Information</button>
          <div className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-2 bg-[#E5E7EB] rounded-lg p-2">
              {
                  tabs.map((text, index) => {
                      return (
                          <div key={index} onClick={() => setActivetab((index + 1))}>
                              {/* <div className={`w-full h-[0.6rem] border rounded-md ${activeTab > index ? 'bg-[#00535C]' : 'bg-[gainsboro]'}`}></div> */}
                              <button className={`rounded-lg p-2 ${activeTab === (index + 1) ? 'bg-[#FFFFFF]' : 'bg-[#E5E7EB]'}`}>{text}</button>
                          </div>
                      )
                  })
              }
          </div>
          <div className="overflow-y-auto max-h-[70vh]">
          {
            activeTab === 1 && ( 
              <div>
                  <div className="bg-[#E5E7EB] rounded-lg p-4 mt-4">
                    <button className="font-aeonik text-center font-medium text-base leading-tight py-2 cursor-pointer whitespace-nowrap ">Basic Information</button>
                    <div className="bg-[#FFFFFF] rounded-lg p-2 mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                      <div className="p-4">
                        <div className="text-[#718096]">First Name</div>
                        <div className="capitalize">{employee?.firstName || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Last Name</div>
                        <div className="capitalize">{employee?.lastName || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Phone Number</div>
                        <div>{employee?.phoneNumber || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
              </div>
            )
          }
          {
            activeTab === 2 && (
              <div>
                  <div className="bg-[#E5E7EB] rounded-lg p-4 mt-4">
                    <button className="font-aeonik text-center font-medium text-base leading-tight py-2 cursor-pointer whitespace-nowrap ">Work Information</button>
                    <div className="bg-[#FFFFFF] rounded-lg p-2 mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                      <div className="p-4">
                        <div className="text-[#718096]">Email Address</div>
                        <div>{employee?.email || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Staff ID</div>
                        <div>{employee?.staffId || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Role</div>
                        <div>{employee?.jobTitle || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Employee Group</div>
                        <div>{employee?.pay_group_id || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Net Monthly Salary</div>
                        <div>₦{employee?.netMonthlySalary || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Gross Monthly Salary</div>
                        <div>₦{employee?.grossAnnualPay || 'N/A'}</div>
                      </div>
                      <div className="p-4">
                        <div className="text-[#718096]">Date Added</div>
                        <div>{DateFullFormat(employee?.createdAt) || 'N/A'}</div>
                      </div>
                    </div>
                  </div>
              </div>
            )
          }
          
          {
            activeTab === 3 && (
              <div>
              <div className="bg-[#E5E7EB] rounded-lg p-4 mt-4">
                <button className="font-aeonik text-center font-medium text-base leading-tight py-2 cursor-pointer whitespace-nowrap ">Bank Information</button>
                <div className="bg-[#FFFFFF] rounded-lg p-2 mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                  <div className="p-4">
                    <div className="text-[#718096]">Bank Name</div>
                    <div>{employee?.bankName || 'N/A'}</div>
                  </div>
                  <div className="p-4">
                    <div className="text-[#718096]">Account Number</div>
                    <div>{employee?.bankAccountNumber || 'N/A'}</div>
                  </div>
                </div>
              </div>
              </div>
            )
          }
          
          {
            activeTab === 4 && (
              <div>
              <div className="bg-[#E5E7EB] rounded-lg p-4 mt-4">
                <button className="font-aeonik text-center font-medium text-base leading-tight py-2 cursor-pointer whitespace-nowrap ">Pension Provider</button>
                <div className="bg-[#FFFFFF] rounded-lg p-2 mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                  <div className="p-4">
                    <div className="text-[#718096]">Pension Provider</div>
                    <div>{employee?.pensionAdministrator || 'N/A'}</div>
                  </div>
                  <div className="p-4">
                    <div className="text-[#718096]">Pension PEN Number</div>
                    <div>{employee?.pensionNumber || 'N/A'}</div>
                  </div>
                  <div className="p-4">
                    <div className="text-[#718096]">Tax Number</div>
                    <div>{employee?.taxIdentificationNumber || 'N/A'}</div>
                  </div>
                </div>
              </div>
              </div>
            )
          }
          </div>
        </div>
      </div>
     </WideViewModal>
  )
 }
 
 export const ViewGroupDataModal = ({ setIsViewGroupOpen, isViewGroupOpen }) => {
  return (
    <WideViewModal isOpen={isViewGroupOpen}  wideViewControl={true} size={"md"} wideViewClassName="w-[60%]" setIsOpen={() => {}}>
    <div className="w-full h-full p-[20px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>View Group</div>
                <div onClick={() => setIsViewGroupOpen(false)}><CloseOutIcon /></div>
            </div>
            <div className="flex justify-end text-[#00535C] underline my-4"><IconEdit /> Edit Information</div>
      <div> 
            <div>
                <div className="bg-[#E5E7EB] rounded-lg p-4 mt-4">
                  <div className="font-aeonik font-medium text-base leading-tight py-2">Group Information</div>
                  <div className="bg-[#FFFFFF] rounded-lg p-2 mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                    <div className="p-4">
                      <div className="text-[#718096]">Group Name</div>
                      <div>Marketing</div>
                    </div>
                    <div className="p-4">
                      <div className="text-[#718096]">Salary Withdrawal Scheme</div>
                      <div>Requires Employers Approval</div>
                    </div>
                    <div className="p-4">
                      <div className="text-[#718096]">Group Salary Withdrawal Limit</div>
                      <div>75%</div>
                    </div>
                    <div className="p-4">
                      <div className="text-[#718096]">Employee Group Access</div>
                      <div>Yes</div>
                    </div>
                  </div>
                </div>
                <div className="bg-[#E5E7EB] rounded-lg p-4 mt-4">
                  <div className="font-aeonik font-medium text-base leading-tight py-2">Employee Group</div>
                  <div className="bg-[#FFFFFF] flex rounded-lg p-4 mt-4 sm:flex-wrap sm:gap-x-6">
                    <div className="border-dotted border-2 border-[#718096] p-2 bg-[#E5E7EB] rounded-lg">
                      Edora Yakoor
                    </div>
                    <div className="border-dotted border-2 border-[#718096] p-2 bg-[#E5E7EB] rounded-lg">
                      Laolu Oyedele
                    </div>
                    <div className="border-dotted border-2 border-[#718096] p-2 bg-[#E5E7EB] rounded-lg">
                      Wen Chu
                    </div>
                  </div>
                </div>
            </div>
      </div>
    </div>
     </WideViewModal>
  )
 }
 
 export const EmployeeEditDetailsModal = ({ isOpen, setIsOpen, employee,  reloadData, getAllGroups, banksLoading, banks }) => {
  const dispatch = useDispatch();
  const {userInfo} = useLoginInfo();
  const { employeeUpdateSuccess, employeeUpdateLoading, employeeEdited } = useSelector((s) => s.entities.employees);
  // const { companyInfoLoading, companyInfo } = useSelector((s) => s.entities.settingsInfo);
  // const { banksLoading, banks } = useSelector((s) => s.ui.banks);
  const { getAllGroupsLoading: groupsLoading, allGroups: groups } = useSelector((s) => s.entities.groups);
  const { pensionProvidersLoading, pensionProvidersData } = useSelector((s) => s.entities.payrollSetup);

  const [activeTab, setActivetab] = useState(1);
  // const [isCompanyInfoFilled, setIsCompanyInfoFilled] = useState(null);
  const [isOpenModalAlert, setIsOpenModalAlert] = useState(false);
  const [formErrors, setFormErrors] = useState({
    firstName: null,
    lastName: null,
    phoneNumber: null,
    email: null,
    jobTitle: null,
    staffId: null,
    payGroup: null,
    netMonthlySalary: null,
    grossAnnualPay: null,
    bankName: null,
    bankCode: null,
    bankAccountNumber: null,
    taxIdentificationNumber: null,
    pensionAdministrator: null,
    pensionNumber: null,
    pensionAdministratorCode: null
});

const [selectedBank, setSelectedBank] = useState(null);
  const [form, setForm] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      jobTitle: "",
      staffId: "",
      payGroup: "",
      netMonthlySalary: "",
      grossAnnualPay: "",
      formattedNet: "",
      formattedGross: "",
      bankName: "",
      bankCode: "",
      bankAccountNumber: "",
      taxIdentificationNumber: "",
      pensionAdministrator: "",
      pensionNumber: "",
      pensionAdministratorCode: "",
  })
  

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
  
  const isButtonDisabled = useMemo(() => {

    if(activeTab === 1 && (form.firstName.length < 2 || form.lastName.length < 2 || form.phoneNumber.length !== 11 )){
      return true;
    } else if(activeTab === 2 && (!validateEmail(form.email) || form.jobTitle.length < 2 || !form.netMonthlySalary)){
      return true;
    } else if(activeTab === 3 && (!form.bankCode || form.bankAccountNumber.length !== 10)){
      return true;
    } else {
      return false;
    }
  }, [form, activeTab])
  
  const banksData = useMemo(() => {
    return banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map((singleBank) => ({
      label: singleBank?.bankName || singleBank?.institutionName,
      value: singleBank?.bankCode || singleBank?.institutionCode,
    })) || [];
  }, [banks])
  
  
  const handleNameChange = (e) => {
    const { name, value } = e.target;
    if ((name === "firstName" || name === "lastName") && (!REGEX_VALUES.LETTERS_WITH_UNDERSCORE_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
      return;
    }
    setForm({...form, [name]: value})
  }
  
  const handleIdChange = (e) => {
    const { name, value } = e.target;
    if ((name === "staffId" ) && (!REGEX_VALUES.LETTERS_WITH_NUMBERS_AND_HYPHEN_ONLY.test(value) || value.length > 50)) {
      return;
    }
    setForm({...form, [name]: value})
  }

  const handlePhoneChange = (e) => {
    const { name, value } = e.target;
    if ((name === "phoneNumber" ) && (REGEX_VALUES.PHONE_NUMBER.test(value) )) {
      setFormErrors({
        ...formErrors,
        phoneNumber: "Phone number must be 11 digits",
    })
    } else {
      setFormErrors({
        ...formErrors,
        phoneNumber: null,
    })
    }
    if ((value.length !== 12) && (value >= 0)) {
        setForm({...form, phoneNumber: value})
    } 
}

const handleEmailChange = (e) => {
  const {name, value} = e.target;
  
  if((name === "email") && (validateEmail(value))) {
    setFormErrors({
      ...formErrors,
      email: null,
  })   
  } else {
    setFormErrors({
      ...formErrors,
      email: "Valid email address is required",
  })
  }
  setForm({...form, email: value})
}

const handleNetMonthlyChange = (e) => {
  const { name, value } = e.target;
  
  if (value === "0") return;
  const cleanedValue = value.replace(/[^\d.]/g, '');
  const [integerPart, decimalPart] = cleanedValue.split('.');
  const formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  let formattedKoboVal = formattedValue;
  if (decimalPart !== undefined) {
      formattedKoboVal += '.' + decimalPart.slice(0, 2);
  }
  // const { newAmount } = applyCharge(formattedKoboVal.replace(/,/g, ''));
  const newAmount  = Number(formattedKoboVal.replace(/,/g, ''));
  setForm({
      ...form,
      // [name]: formattedKoboVal,
      formattedNet: formattedKoboVal,
      netMonthlySalary: newAmount,
      
  });
}

const handleGrossMonthlyChange = (e) => {
const { name, value } = e.target;
  
if (value === "0") return;
const cleanedValue = value.replace(/[^\d.]/g, '');
const [integerPart, decimalPart] = cleanedValue.split('.');
const formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
let formattedKoboVal = formattedValue;
if (decimalPart !== undefined) {
formattedKoboVal += '.' + decimalPart.slice(0, 2);
}
const newAmount  = Number(formattedKoboVal.replace(/,/g, ''));
setForm({
...form,
// [name]: formattedKoboVal,
formattedGross: formattedKoboVal,
grossAnnualPay: newAmount,

});
}

// const handleNetMonthlyChange = (val) => {
//   if(val <= 0){
//       setForm({...form, netMonthlySalary: 0})
//   }
//   else if ((val.length !== 15) && (val >= 0)) {
//           setForm({...form, netMonthlySalary: val.toFixed()})
//   } else{
//       setForm({...form, netMonthlySalary: val})
//   }
// }

// const handleGrossMonthlyChange = (val) => {
//   if(val <= 0){
//       setForm({...form, grossAnnualPay: 0})
//   }
//   else if ((val.length !== 15) && (val >= 0)) {
//           setForm({...form, grossAnnualPay: val.toFixed()})
//   } else{
//       setForm({...form, grossAnnualPay: val})
//   }
// }

const handleBankAccountNumberChange = (val) => {
  if(REGEX_VALUES.NUMBERS_ONLY.test(val)){
    return;
  }
  if(val < 0){
      setForm({...form, bankAccountNumber: val * -1})
  }
  else if ((val.length !== 11) && (val >= 0)) {
          setForm({...form, bankAccountNumber: val})
  }

}

  const getBankName = () => {
      const bankData = banks;
      for (var i = 0; i < bankData?.length; i++){
          if ((bankData[i]?.bankCode || bankData[i]?.institutionCode) === form.bankCode){
              return (bankData[i]?.bankName || bankData[i]?.institutionName);
          }
      }
      return null;
  }


  const getPfaCode = () => {
      const selectedAdministrator = pensionProvidersData?.data?.find((item) => item?.name === form?.pensionAdministrator);
      if(selectedAdministrator) {
          return selectedAdministrator?.pfa_code;
      }
  }
  
  const removeEmptyFields = (obj) => {
    Object.keys(obj)?.forEach(key => obj[key] === "" && delete obj[key]);
    return obj;
}


  const submitForm = async e => {
    e.preventDefault();
    if (activeTab < 4 ) {
      setActivetab((prevState => prevState + 1));
      return;
    }
      const {formattedNet, formattedGross, ...editedForm} = form
      const validateForm = {...editedForm};
      delete validateForm["resumedAt"];
      delete validateForm["pensionAdministrator"];
      delete validateForm["pensionNumber"];
      delete validateForm["taxIdentificationNumber"];
      delete validateForm["pensionAdministratorCode"];
      delete validateForm["staffId"];
      delete validateForm["grossAnnualPay"];
      delete validateForm["payGroup"];
      const errors = validate(validateForm);
      if (errors){
          for (var x in errors) {
              toast.error(errors[x]);
          };
          return;
      }
      else{
          const bankName = getBankName();
          const pensionAdministratorCode = getPfaCode();
          const params = {...editedForm, bankName, pensionAdministratorCode};
          const payload = removeEmptyFields(params)
          setForm(payload);
          dispatch(employeesActions.editEmployee(employee?._id, payload));
          
      }
  }
  
  const currentValues = {
    firstName: employee?.firstName || "",
    lastName: employee?.lastName || "",
    email: employee?.email || "",
    phoneNumber: (employee?.phoneNumber?.length === 10 ? `0${employee?.phoneNumber}` : employee?.phoneNumber) || "",
    jobTitle: employee?.jobTitle || "",
    staffId: employee?.staffId || "",
    payGroup: employee?.payGroup || "",
    netMonthlySalary: employee?.netMonthlySalary || "",
    grossAnnualPay: employee?.grossAnnualPay || "",
    formattedNet: employee?.netMonthlySalary || "",
    formattedGross: employee?.grossAnnualPay || "",
    bankName: employee?.bankName || "",
    bankCode: employee?.bankCode || "",
    bankAccountNumber: employee?.bankAccountNumber || "",
    taxIdentificationNumber: employee?.taxIdentificationNumber || "",
    pensionAdministrator: employee?.pensionAdministrator || "",
    pensionNumber: employee?.pensionNumber || "",
    pensionAdministratorCode: employee?.pensionAdministratorCode || "",
}
  
  useEffect(() => {
    setForm(
      {
        ...currentValues
      }
    )
    setSelectedBank({
      label: employee?.bankName,
      value: employee?.bankCode,
    })
    // eslint-disable-next-line
  }, [employee]);



  const resetForm = () => {
      setForm({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          jobTitle: "",
          staffId: "",
          payGroup: "",
          netMonthlySalary: "",
          grossAnnualPay: "",
          formattedNet: "",
          formattedGross: "",
          bankName: "",
          bankCode: "",
          bankAccountNumber: "",
          taxIdentificationNumber: "",
          pensionAdministrator: "",
          pensionNumber: "",
          pensionAdministratorCode: "",
      })
      setActivetab(1)
      setSelectedBank(null);
  }
  
  const handleCloseEditEmployeeModal = () => {
    resetForm();
    setIsOpen((prevState) => !prevState);
  }


  
  useEffect(() => {
      dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
      dispatch(banksActions.getAllBanks());
      dispatch(groupsActions.getAllGroups());
      dispatch(payrollSetupActions.getPensionProviders());
      // eslint-disable-next-line
  }, [])

  useEffect(() => {
      if (employeeEdited?.status === "success"){
        setIsOpen((prevState) => !prevState);
        toast.success(employeeEdited?.message);
            // setIsOpenModalAlert(true);
        reloadData();
        resetForm();
        dispatch(employeesActions.resetEmployeeEditSuccess());
          // if (!employeeCreateStatus?.jobId){
          //     // history.push("/employees");
          //     setIsOpenModalAlert(true);
          //     resetForm();
          // }
      }
      // eslint-disable-next-line
  }, [employeeEdited]);
  
  
  return (
    <WideViewModal isOpen={isOpen} wideViewControl={true} size={"md"} wideViewClassName="w-[60%]" setIsOpen={handleCloseEditEmployeeModal}>
    <ModalAlert
        successText="Changes saved successfully!"
        // dismissText="Add Another Employee"
        isOpenModalAlert={isOpenModalAlert}
        setIsOpenModalAlert={setIsOpenModalAlert}
    />
    <div className="w-full h-full p-[32px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>Edit Employee</div>
                <button type="button" onClick={handleCloseEditEmployeeModal}><CloseOutIcon /></button>
            </div>
      <form onSubmit={submitForm}>
        <div className="grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-2">
            {
                tabs.map((text, index) => {
                    return (
                        <div key={index}>
                            <div className={`w-full h-[0.6rem] border rounded-md ${activeTab > index ? 'bg-[#00535C]' : 'bg-[gainsboro]'}`}></div>
                            <div className={`py-2 ${activeTab > index ? 'text-[#374151]' : 'text-[#718096]'}`}>{text}</div>
                        </div>
                    )
                })
            }
        </div>
        {
          activeTab === 1 && ( 
            <div>
                <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                    <Input type="text" label="First Name" placeholder="Enter Employee First Name" required={true} name="firstName" value={form.firstName} onChange={handleNameChange} inputClass="capitalize" />
                    <Input type="text" label="Last Name" placeholder="Enter Employee Last Name" required={true} name="lastName" value={form.lastName} onChange={handleNameChange} inputClass="capitalize" />
                    <Input type="tel" leftIcon={<PhoneNumberCodeIcon />} leftIconClass="w-[50px] h-[16px] top-3 left-2" leftIconInputClass="pl-[5rem]" label="Phone Number" placeholder="Enter Employee Phone Number" required={true} value={form.phoneNumber} onChange={handlePhoneChange} 
                    tagText={formErrors?.phoneNumber}
                    tagTextIsRed
                    />
                </div>
            </div>
          )
        }
        {
          activeTab === 2 && (
            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <Input type="email" label="Email Address" name="email" placeholder="Enter Employee Email Address" required={true} value={form.email} onChange={handleEmailChange} 
                tagText={formErrors?.email}
                tagTextIsRed
                />
                <Input type="text" label="Staff ID (optional)" placeholder="Enter Staff ID Number" value={form.staffId} name="staffId"  onChange={handleIdChange} />
                <Input type="text" label="Role" placeholder="Enter Role" required={true} value={form.jobTitle} onChange={(e) => setForm({...form, jobTitle: e.target.value})} />
                <div>
                    {(groupsLoading === true) && 
                        <Input type="text" label="Employee Group (optional)" value="Loading groups..." disabled={true} />
                    }
                    {(groupsLoading === false) && 
                        <SelectInput label="Employee Group (optional)" value={form.payGroup} onChange={(e) => setForm({...form, payGroup: e.target.value})}>
                            <option value="">Select Group</option>
                            {/* <option value="general-group">General Group</option> */}
                            {groups?.data?.map(group => (
                                <option key={group.id} value={group.id}>{group.name}</option>
                            ))}
                        </SelectInput>
                    }
                </div>
                {/* <Input type="text" name="formattedNet" label="Net Monthly Salary" placeholder="Enter Amount" min={0} className="input-number" required={true} value={form.formattedNet} onChange={handleNetMonthlyChange} />
                <Input type="text" name="formattedGross" label="Gross Monthly Salary (optional)" placeholder="Enter Amount" min={0} className="input-number" value={form.formattedGross} onChange={handleGrossMonthlyChange} /> */}
                <div className="relative">
                  <Input type="text" name="formattedNet"  label="Net Monthly Salary" placeholder="Enter Amount" required={true} value={form.formattedNet} className="input-number !pl-7" onChange={handleNetMonthlyChange} />
                  <div className="absolute left-3 top-8">₦&nbsp;</div>
                </div>
                <div className="relative">
                  <Input type="text" name="formattedGross" label="Gross Monthly Salary (optional)" placeholder="Enter Amount" value={form.formattedGross} className="input-number !pl-7" onChange={handleGrossMonthlyChange} />
                  <div className="absolute left-3 top-8">₦&nbsp;</div>
                </div>
            </div>
          )
        }
        
        {
          activeTab === 3 && (
            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <div>
                    {/* {(banksLoading === true) && 
                        <Input type="text" label="Bank Name" required={true} value="Loading banks..." disabled={true} />
                    }
                    {(banksLoading === false) && 
                        <SelectInput label="Bank Name" required={true} value={form.bankCode} onChange={(e) => setForm({...form, bankCode: e.target.value})}>
                            <option value="">Select Bank</option>
                            {banks?.sort((a, b) => (a?.bankName || a?.institutionName)?.localeCompare(b?.bankName || b?.institutionName))?.map(bank => (
                                <option key={bank?.bankId || bank?.id} value={bank?.bankCode || bank?.institutionCode}>{bank?.bankName || bank?.institutionName}</option>
                            ))}
                        </SelectInput>
                    } */}
                    <p className="text-sm mb-1">Bank Name <span className="form-input-required">*</span></p>
                    <ReactSelect
                      isDisabled={banksLoading}
                      isLoading={banksLoading}
                      isSearchable
                      defaultValue={selectedBank}
                      onChange={(selected) => {
                        setSelectedBank(selected);
                        setForm({
                          ...form, 
                          bankCode: selected.value,
                          bankName: selected.label
                        });
                      }}
                      options={banksData}
                      styles={reactSelectStyles}
                      placeholder={banksLoading ? "Fetching banks..." : "Select Bank"}
                      noOptionsMessage={() => "No Banks Found"}
                    />
                </div>
                <Input type="text" label="Account Number" placeholder="Enter Bank Account Number"  min={0}  required={true} className="input-number" value={form.bankAccountNumber} onChange={(e) => handleBankAccountNumberChange(e.target.value)} />
            </div>
          )
        }
        
        {
          activeTab === 4 && (
            
            <div className="mt-4 sm:grid sm:grid-cols-2 sm:gap-x-6">
                <div>
                    <SelectInput disabled={pensionProvidersLoading} label="Pension Provider (Optional)" required={false} value={form.pensionAdministrator || ""} onChange={(e) => setForm({...form, pensionAdministrator: e.target.value})}>
                        <option value="">{pensionProvidersLoading ? "Fetching providers..." : form?.pensionAdministrator?.length ? form?.pensionAdministrator : "Select Provider"}</option>
                        {pensionProvidersData?.data?.map((item) => (
                            <option key={item?.name} value={item?.name}>{item?.name}</option>
                        ))}
                    </SelectInput>
                </div>
                <Input type="text" label="PEN Number (Optional)" placeholder="Enter PEN Number" required={false} value={form.pensionNumber || ""} onChange={(e) => setForm({...form, pensionNumber: e.target.value})} />
                <Input type="number" label="Tax Number (Optional)" placeholder="Enter here" required={false} value={form.taxIdentificationNumber || ""} onChange={(e) => setForm({...form, taxIdentificationNumber: e.target.value})} />
            </div>
          )
        }
        
        <div className="mt-4 flex justify-end space-x-4">
          <button type="button" onClick={() => activeTab === 1 ? handleCloseEditEmployeeModal() : setActivetab((prevState => prevState - 1))} className="btn btn-transparent-primary">
              {activeTab > 1 && activeTab <= 4 ? "Back" : "Cancel"}
          </button>
          <ButtonLoader type="submit" disabled={isButtonDisabled} loading={employeeUpdateLoading} className="btn btn-ep-primary">
              {activeTab < 4 ? "Next" : "Save Changes"}
          </ButtonLoader>
        </div>
      </form>
    </div>
     </WideViewModal>
  )
 }
 
 // unused comp:::
 export const EmployeeEditModal = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const {userInfo} = useLoginInfo();
  const { employeeCreateLoading, employeeCreateSuccess, employeeCreateStatus } = useSelector((s) => s.entities.employees);
  // const { companyInfoLoading, companyInfo } = useSelector((s) => s.entities.settingsInfo);
  const { banks } = useSelector((s) => s.ui.banks);
  const { pensionProvidersData } = useSelector((s) => s.entities.payrollSetup);

  
  // const [isCompanyInfoFilled, setIsCompanyInfoFilled] = useState(null);
  const [setIsOpenModalAlert] = useState(false);
  
  const [form, setForm] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      jobTitle: "",
      staffId: "",
      payGroup: "",
      netMonthlySalary: "",
      grossAnnualPay: "",
      bankName: "",
      bankCode: "",
      bankAccountNumber: "",
      taxIdentificationNumber: "",
      pensionAdministrator: "",
      pensionNumber: "",
      pensionAdministratorCode: "",
  })


  const getBankName = () => {
    const bankData = banks;
    for (var i = 0; i < bankData?.length; i++){
        if ((bankData[i].bankCode || bankData[i].institutionCode) === form.bankCode){
            return (bankData[i].bankName || bankData[i].institutionName);
        }
    }
    return null;
}


  const getPfaCode = () => {
      const selectedAdministrator = pensionProvidersData?.data?.find((item) => item?.name === form?.pensionAdministrator);
      if(selectedAdministrator) {
          return selectedAdministrator?.pfa_code;
      }
  }
  



  const submitForm = async e => {
    e.preventDefault();
      const validateForm = {...form};
      delete validateForm["resumedAt"];
      delete validateForm["pensionAdministrator"];
      delete validateForm["pensionNumber"];
      delete validateForm["taxIdentificationNumber"];
      delete validateForm["pensionAdministratorCode"];
      delete validateForm["staffId"];
      delete validateForm["grossAnnualPay"];
      delete validateForm["grossAnnualPay"];
      const errors = validate(validateForm);
      if (errors){
          for (var x in errors) {
              toast.error(errors[x]);
          };
          return;
      }
      else{
          const bankName = getBankName();
          const pensionAdministratorCode = getPfaCode();
          const params = {...form, bankName, pensionAdministratorCode};
          setForm(params);
          // dispatch(employeesActions.editEmployee(employee?._id, params));
      }
  }


  const resetForm = () => {
      setForm({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          jobTitle: "",
          staffId: "",
          payGroup: "",
          netMonthlySalary: "",
          grossAnnualPay: "",
          bankName: "",
          bankCode: "",
          bankAccountNumber: "",
          taxIdentificationNumber: "",
          pensionAdministrator: "",
          pensionNumber: "",
          pensionAdministratorCode: "",
      })
  }


  useEffect(() => {
      dispatch(infoActions.getInfo(userInfo?.company?.selectedCompanyId));
      dispatch(banksActions.getAllBanks());
      dispatch(groupsActions.getAllGroups());
      dispatch(payrollSetupActions.getPensionProviders());
      // eslint-disable-next-line
  }, [])

  useEffect(() => {
      if (employeeCreateSuccess === true){
          dispatch(employeesActions.resetEmployeeCreateSuccess());
          if (!employeeCreateStatus?.jobId){
              // history.push("/employees");
              setIsOpenModalAlert(true);
              resetForm();
          }
      }
      // eslint-disable-next-line
  }, [employeeCreateSuccess]);
  
  return (
    <WideViewModal isOpen={false} zIndex="z-[9999]"  wideViewControl={true} size={"sm"} wideViewClassName="w-[40%]" setIsOpen={() => {}}>
    {/* <EmployeeActionModal
      isOpen={isOpenModalEditAlert}
      setIsOpen={setIsOpenModalEditAlert}
      title="Save All Changes"
      question="Are you sure you want to perfome this action?"
      actionType="positive"
    /> */}

    <div className="w-full h-full p-[32px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>Edit This Entry</div>
                <div onClick={() => setIsOpen(false)}><CloseOutIcon /></div>
            </div>
      <form onSubmit={submitForm}>
            <div>
                <div className="mt-4">
                    <Input type="text" label="First Name" required={true} value={form.firstName} onChange={(e) => setForm({...form, firstName: e.target.value})} inputClass="capitalize" />
                    <Input type="text" label="Last Name" placeholder="Enter Employee Last Name" required={true} value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} inputClass="capitalize" />
                    <Input type="text" label="Email Address" placeholder="Enter Employee Email Address" required={true} value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} inputClass="capitalize" />
                    <Input type="text" label="Job Title" placeholder="Enter Employee Job Title" required={true} value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} inputClass="capitalize" />
                    <Input type="text" label="Net Pay" placeholder="Enter Employee Net Pay" required={true} value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} inputClass="capitalize" />
                </div>
            </div>
        
        <div className="mt-4 flex justify-end space-x-4">
          <button type="button" onClick={() => {}} className="btn btn-transparent-primary">
              Cancel
          </button>
          <ButtonLoader type="submit" loading={employeeCreateLoading} className="btn btn-ep-primary">
              Save Changes
          </ButtonLoader>
        </div>
      </form>
    </div>
     </WideViewModal>
  )
 }

 export const EmployeeUploadReviewCSVModal = ({ pageAccess, employeesLoading, employees, setIsEmployeeActionOpen, isOpenBulkUploadReview, setIsOpenBulkUploadReview, jobId, setJobId, uploadDataPreview }) => {
  // const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  // const [editDetails, setEditDetails] = useState(null);
  
  // const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections } = useMultiSelect();

  const dispatch = useDispatch();
  const { employeeUploadStatusLoading, employeeUploadStatus } = useSelector((s) => s.entities.employees);

  let interval = useRef();

  const [ isOpenBulkUpload, setIsOpenBulkUpload] = useState(false);
  const [inputEmployee, setInputEmployee] = useState(false);
  const [status, setStatus] = useState("");

  const [uploadResultSuccess, setUploadResultSuccess] = useState([]);
  const [uploadResultSuccessLength, setUploadResultSuccessLength] = useState(0);
  const [uploadResultErrors, setUploadResultErrors] = useState([]);
  const [uploadResultErrorsLength, setUploadResultErrorsLength] = useState(0);
  const [setEmployeeUploadStatusDownload] = useState([]);
  // const [employeeUploadStatusDownloadLoading, setEmployeeUploadStatusDownloadLoading] = useState(false);
  const [ setParsedData] = useState([]);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    jobTitle: "",
    netMonthlySalary: "",
    grossAnnualPay: "",
    bankCode: "",
    bankAccountNumber: "",
  });
  
//   const deleteEntry = () => {
//     const filteredEntries = parsedData?.filter((item) => item?.id !== entryToDelete?.id)
    
//     setParsedData(filteredEntries)
// }

// const updateCsvEntry = (entry) => {
//     const editedEntries = parsedData?.map((item) => item?.id === entry?.id ? {...entry} : item)
    
//     setParsedData(editedEntries)
// }

  const renderResults = (type, data) => {
    let response = [];
    let responseEmailAndPhoneNumber = [];
    data.forEach((d) => {
      if (!responseEmailAndPhoneNumber.includes(d.email) && !responseEmailAndPhoneNumber.includes(d.phoneNumber)){
        const entry = {...d, status: (type === "success") ? "Uploaded" : "Failed"};
        response.push(entry);
        responseEmailAndPhoneNumber.push(d.email);
      }
    })
    return response;
  }


  const getResults = async () => {
      dispatch(employeesActions.uploadEmployeesExcelStatus(jobId));
  }


  /* const getDownloadList = () => {
      let data = [];
      if (employeeUploadStatus?.data?.successList){
          data = [...data, ...employeeUploadStatus?.data?.successList];
      }
      if (employeeUploadStatus?.data?.errorList){
          data = [...data, ...employeeUploadStatus?.data?.errorList];
      }
      setEmployeeUploadStatusDownload(data);
  } */
  
  const removeEmployee = () => {
      let data = [];
      if (employeeUploadStatus?.data?.successList){
          data = [...data, ...employeeUploadStatus?.data?.successList];
      }
      if (employeeUploadStatus?.data?.errorList){
          data = [...data, ...employeeUploadStatus?.data?.errorList];
      }
      setEmployeeUploadStatusDownload(data);
  }


  // useEffect(() => {
  //     if (jobId){
  //         getResults();
          
  //         interval.current = setInterval(() => {
  //             getResults();
  //         },  15 * 1000); 
  //     }
  //     // eslint-disable-next-line
  // }, [jobId])
  
  useEffect(() => {
    if (jobId){
      dispatch(employeesActions.uploadEmployeesExcelStatus(jobId));
      setJobId(null);
    }
  }, [jobId])


  // useEffect(() => {
  //     setIsOpenBulkUpload(false);
  //     // eslint-disable-next-line
  // }, [employeeUploadStatus])

  
  useEffect(() => {
    if (employeeUploadStatus?.status === "success"){
      const data = employeeUploadStatus?.data;

      const newUploadResultSuccess = renderResults("success", data.successList);
      const newUploadResultSuccessLength = newUploadResultSuccess.length;
      const newUploadResultErrors = renderResults("error", data.errorList);
      const newUploadResultErrorsLength = newUploadResultErrors.length;
      
      setUploadResultSuccess(newUploadResultSuccess);
      setUploadResultSuccessLength(newUploadResultSuccessLength);
      setUploadResultErrors(newUploadResultErrors);
      setUploadResultErrorsLength(newUploadResultErrorsLength);
      
      if (newUploadResultSuccessLength + newUploadResultErrorsLength === employeeUploadStatus?.data?.totalCount){
        setStatus("cancelInterval");
      } else{
        setStatus("ongoing");
      }
      dispatch(employeesActions.resetUploadEmployeeStatus());
    }
  }, [employeeUploadStatus])

    
  // useEffect(() => {
  //   if(uploadResultErrors.length > 0) {
  //     setParsedData([...uploadResultErrors, ...uploadResultSuccess]);
  //   }
  // }, [uploadResultErrors])

//   useEffect(() => {
//       if (status === "cancelInterval"){
//           clearInterval(interval.current);
//       }
//       // eslint-disable-next-line
//   }, [status])
  
  return (
    <WideViewModal isOpen={isOpenBulkUploadReview}  wideViewControl={true} size={"md"} wideViewClassName="w-[60%]" setIsOpen={() => setIsOpenBulkUploadReview()}>
      <div>
      {/* <EmployeeEditModal
        editDetails={editDetails}
        isOpen={isEditModalOpen}
        setIsOpen={setIsEditModalOpen}
        setEditDetails={setEditDetails}
      /> */}
      <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[12px] flex justify-between">
          <div>Review CSV</div>
      </div>
      
      <div className="flex justify-between items-center bg-[#FEF2F2] rounded p-4">
        <div className="flex items-center gap-2">
          <ErrorAlertIcon />
          <div><span className="text-[#DC2626]">{uploadResultErrorsLength} Errors Detected</span> -  {uploadResultSuccessLength}/{employeeUploadStatus?.data?.totalCount}</div>
        </div>
        <div>
          <ButtonLoader type="submit" loading={false} className="btn bg-[#DC2626] text-[#FFFFFF]">
              Review entries with errors
          </ButtonLoader>
        </div>
      </div>
             
      <div className="font-aeonik text-lg font-thin leading-7 text-left mt-6 mb-[12px]">
        {employeeUploadStatus?.data?.totalCount} Employees Entries
      </div>
                      
      <div className="">
                <div className="">
                    <div>
                        <Table>
                            <Table.Head>
                                <th>SN</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email Address</th>
                                <th>Phone Number</th>
                                <th>Job Title</th>
                                <th>Net Pay</th>
                                <th>Annual Pay</th>
                                <th>Bank Code</th>
                                <th>Account Number</th>
                                <th>Status</th>
                                <th>Reason</th>
                                <th></th>
                            </Table.Head>
                            <Table.Body>

                                <Maybe condition={employeeUploadStatusLoading}>
                                    <TableContentCustom
                                        loading={true}
                                        text="Checking status"
                                        colspan={7}
                                    />
                                </Maybe>

                                <Maybe condition={!employeeUploadStatusLoading && employeeUploadStatus && employeeUploadStatus?.totalCount === 0}>
                                    <TableContentCustom
                                        icon="unlink"
                                        text="No status found"
                                        colspan={7}
                                    />
                                </Maybe>

                                {/* <Maybe condition={!employeeUploadStatusLoading}>
                                    <TableContentCustom
                                      loading={true}
                                      text="Status: uploading employees"
                                      colspan={7}
                                    />
                                </Maybe> */}

                                {!employeeUploadStatusLoading && uploadResultErrorsLength > 0 && 
                                    uploadResultErrors.map((employee, index) =>
                                        <tr key={index}>
                                            <td>
                                                {++index}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.firstName}
                                                      placeholder={employee?.firstName}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, firstName: e.target.value})}
                                                  />)  : employee.firstName}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.lastName}
                                                      placeholder={employee?.lastName}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, lastName: e.target.value})}
                                                  />)  : employee.lastName}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.email}
                                                      placeholder={employee?.email}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, email: e.target.value})}
                                                  />)  : employee.email}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.phoneNumber}
                                                      placeholder={employee?.phoneNumber}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, phoneNumber: e.target.value})}
                                                  />)  : employee.phoneNumber}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.jobTitle}
                                                      placeholder={employee?.jobTitle}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, jobTitle: e.target.value})}
                                                  />)  : employee.jobTitle}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.netMonthlySalary}
                                                      placeholder={employee?.netMonthlySalary}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, netMonthlySalary: e.target.value})}
                                                  />)  : employee.netMonthlySalary}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.grossAnnualPay}
                                                      placeholder={employee?.grossAnnualPay}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, grossAnnualPay: e.target.value})}
                                                  />)  : employee.grossAnnualPay}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.bankCode}
                                                      placeholder={employee?.bankCode}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, bankCode: e.target.value})}
                                                  />)  : employee.bankCode}
                                            </td>
                                            <td>
                                                { inputEmployee ? (<Input
                                                      type="text"
                                                      value={form?.bankAccountNumber}
                                                      placeholder={employee?.bankAccountNumber}
                                                      className="form-input"
                                                      onChange={(e) => setForm({...form, bankAccountNumber: e.target.value})}
                                                  />)  : employee.bankAccountNumber}
                                            </td>
                                            <td>
                                                <div className={"label " + renderStatusColor("failed")}>
                                                    Failed
                                                </div>
                                            </td>
                                            <td style={{"minWidth":"300px","whiteSpace":"normal"}}>
                                                <div className="break-words">
                                                    {employee.message}
                                                </div>
                                            </td>
                                            <td style={{"whiteSpace":"normal"}}>
                                                    <DropDown 
                                            titleIcon={ <IconNav style={{ height: "26px" }} className="w-8 px-1.5 py-0.5 relative cursor-pointer group-hover:bg-gray-300 rounded transform rotate-180" />} 
                                                listClass="flex gap-2 item-center p-2 w-[200px] cursor-pointer hover:bg-[#00535C] hover:text-[#FFFFFF]" 
                                                triggerClass="" 
                                                dropdownArray={[
                                              {
                                                  title: "Edit",
                                                  func: () => setInputEmployee((prevData) => !prevData)
                                              },
                                              {
                                                  title: "Remove",
                                                  color: 'text-[#DC2626]',
                                                  func: () => removeEmployee((prevState) => !prevState)
                                              },
                                    ]}/>
                                            </td>
                                        </tr>
                                    )
                                }
                                
                                {!employeeUploadStatusLoading && uploadResultSuccessLength > 0 && 
                                    uploadResultSuccess.map((employee, index) =>
                                        <tr key={index}>
                                            <td>
                                                {uploadResultErrorsLength + index + 1}
                                            </td>
                                            <td>
                                                {employee.firstName}
                                            </td>
                                            <td>
                                                {employee.lastName}
                                            </td>
                                            <td>
                                                {employee.email}
                                            </td>
                                            <td>
                                                {employee.phoneNumber}
                                            </td>
                                            <td>
                                                {employee.jobTitle}
                                            </td>
                                            <td>
                                                {employee.netMonthlySalary}
                                            </td>
                                            <td>
                                                {employee.grossAnnualPay}
                                            </td>
                                            <td>
                                                {employee.bankCode}
                                            </td>
                                            <td>
                                                {employee.bankAccountNumber}
                                            </td>
                                            <td>
                                                <div className={"label " + renderStatusColor("success")}>
                                                    Uploaded
                                                </div>
                                            </td>
                                            <td style={{"minWidth":"300px","whiteSpace":"normal"}}>
                                                <div className="break-words">
                                                    {employee.message}
                                                </div>
                                            </td>
                                            <td style={{"minWidth":"300px","whiteSpace":"normal"}}>
                                        
                                            </td>
                                        </tr>
                                    )
                                }

                            </Table.Body>
                        </Table>

                    </div>
                </div>
      </div>

        <div className="mt-4 flex justify-end space-x-4">
          <button type="button" onClick={() => setIsOpenBulkUploadReview(false)} className="btn btn-transparent-primary">
              Cancel
          </button>
          <ButtonLoader type="submit" loading={false} className="btn btn-ep-primary">
              Complete Upload
          </ButtonLoader>
        </div>
      </div>
    </WideViewModal>
  )
 }
 
 export const AssignToGroupModal = (props) => {
  const { setIsAssignGroupOpen, isAssignGroupOpen, employee} = props;
  const dispatch = useDispatch();
  const {getPayGroupData: payGroupsData, getPayGroupLoading: loading, updatePayGroupEmployeesLoading, paygroupEmployeeUpdateSuccess} = useSelector(state => state.entities.payrollSetup)
  // const [params, setParams] = useState(assignToGroupParams);
  const [selectedPayGroup, setSelectedPayGroup] = useState({});
  
  const isSubmitBtnDisabled = useMemo(() => Object.entries(selectedPayGroup).length === 0, [selectedPayGroup]);
  
  
  /* const selectGroup = (payGroup) => {
      setParams({
          ...params,
          params: {
              ...params.params,
              policyId: payGroup
          }
      })
  } */
  
  const handleCloseAssignGroupModal = () => {
    setSelectedPayGroup({})
    setIsAssignGroupOpen(false)  
  }


  const submitForm = (e) => {
    e.preventDefault();
    // const errors = validate(params.params);
    // if (errors){
    //     for (var x in errors) {
    //         toast.error(errors[x]);
    //     };
    //     return;
    // }
    // else{
    //     const payload = {
    //         policyId: params.params.policyId,
    //         employeeIds: params.params.employeeId,
    //     }
    //     dispatch(groupsActions.assignEmployeeToGroup(payload));
    // }
      
    const payload = {
      id: Object.keys(selectedPayGroup)[0],
      employee_ids: [employee?._id],
    }
    dispatch(payrollSetupActions.assignPayGroupEmployees(payload));
  }


  // useEffect(() => {
  //     setParams(assignToGroupParams);
  // }, [assignToGroupParams])
  
  useEffect(() => {
    dispatch(payrollSetupActions.getPayGroups());
    // eslint-disable-next-line
  }, [])

  // useEffect(() => {
  //     if (assignEmployeeToGroupSuccess === true){
  //         setParams({...params, isOpen: false});
  //         props.reloadData();
  //     }
  //     // eslint-disable-next-line
  // }, [assignEmployeeToGroupSuccess])
  
  useEffect(() => {
      if (paygroupEmployeeUpdateSuccess){
        dispatch(payrollSetupActions.resetPayGroupEmployeesAssignment());
        handleCloseAssignGroupModal();
      }
      // eslint-disable-next-line
  }, [paygroupEmployeeUpdateSuccess])
  
  return (
    <WideViewModal isOpen={isAssignGroupOpen}  wideViewControl={true} size={"xs"} wideViewClassName="w-[40%]" setIsOpen={() => {}}>
    <div className="w-full h-full p-[22px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>Assign to Group</div>
                <div onClick={handleCloseAssignGroupModal}><CloseOutIcon /></div>
            </div>  
            <div className="flex mb-[2rem]">
              <div className="w-full">
                <SearchBox placeholder="Search Group" name="search" extraUrlParams="page=1" />
              </div>
           </div>
      <form onSubmit={submitForm}>
       {/*  {
         !getAllGroupsLoading && [
          {
            id: 1,
            name: "Products",
            count: 14
          },
          {
            id: 2,
            name: "Engineering",
            count: 23
          },
          {
            id: 3,
            name: "Sales",
            count: 12
          },
          {
            id: 4,
            name: "Marketting",
            count: 8
          },
        ]?.map((option, index) => {
            return (
              <div key={index} className="flex items-center mb-2 p-2">
          <input
            type="radio"
            id={option.id}
            name="custom-radio"
            value={option.id}
            checked={params === option.id}
            onChange={selectGroup}
            className="form-radio h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
          />
          <label htmlFor={option.id} className="ml-2 block text-sm leading-5 text-gray-700">
            <span className=" font-bold">{option.name}</span> <span className="font-thin text-[#667085]">{option.count} Employees</span>
          </label>
              </div>
            )
          })
        } */}
        
        {loading ? (
          <Spinner message={loading ? "Fetching Pay Groups" : ""} /> 
        ) : 
          (payGroupsData?.data?.map((payGroup, index) => {
            return (
              <div key={payGroup?.id || index} className="flex items-center mb-2 p-2">
                <input
                  type="radio"
                  id={payGroup?.id}
                  name="custom-radio"
                  checked={selectedPayGroup?.[payGroup?.id]}
                  onChange={() => {
                    setSelectedPayGroup({
                      [payGroup?.id]: !selectedPayGroup?.[payGroup?.id],
                    })
                  }}
                  className="form-radio h-4 w-4 text-blue-600 transition duration-150 ease-in-out"
                />
                <label htmlFor={payGroup?.id} className="ml-2 block text-sm leading-5 text-gray-700">
                  <span className=" font-bold">{payGroup?.name}</span> <span className="font-thin text-[#667085]">{payGroup?.employee_ids?.length} Employees</span>
                </label>
              </div>
              )
            })
          )
        }
        
        <div className="mt-4 flex">
          <ButtonLoader type="submit" disabled={isSubmitBtnDisabled || updatePayGroupEmployeesLoading} loading={loading || updatePayGroupEmployeesLoading} className={`border btn w-full ${isSubmitBtnDisabled ? "" : "hover:btn-ep-primary"}`}>
            {updatePayGroupEmployeesLoading ? "Assigning" : "Assign"}
          </ButtonLoader>
        </div>
      </form>
    </div>
</WideViewModal>
  )
 }
 
 export const EditEmployeeGroupModal = (props) => {
  const {assignToGroupParams, setIsEditEmployeeGroupOpen, isEditEmployeeGroupOpen} = props;
  const dispatch = useDispatch();
  const { getAllGroupsLoading, assignEmployeeToGroupSuccess } = useSelector((s) => s.entities.groups);
  const [params, setParams] = useState(assignToGroupParams);
  
  
/*   const selectGroup = (payGroup) => {
      setParams({
          ...params,
          params: {
              ...params.params,
              policyId: payGroup
          }
      })
  } */

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
})

  const submitForm = (e) => {
      e.preventDefault();
      const errors = validate(params.params);
      if (errors){
          for (var x in errors) {
              toast.error(errors[x]);
          };
          return;
      }
      else{
          const payload = {
              policyId: params.params.policyId,
              employeeIds: params.params.employeeId,
          }
          dispatch(groupsActions.assignEmployeeToGroup(payload));
      }
  }


  useEffect(() => {
      setParams(assignToGroupParams);
  }, [assignToGroupParams])


  useEffect(() => {
      if (assignEmployeeToGroupSuccess === true){
          setParams({...params, isOpen: false});
          props.reloadData();
      }
      // eslint-disable-next-line
  }, [assignEmployeeToGroupSuccess])
  
  const employees = [
    {
      id: 1,
      name: "Edora Yakoor"
    },
    {
      id: 2,
      name: "Laolu Oyedele"
    },
    {
      id: 3,
      name: "Wen Chu"
    },
  ]
  return (
    <WideViewModal isOpen={isEditEmployeeGroupOpen}  wideViewControl={true} size={"xs"} wideViewClassName="w-[40%]" setIsOpen={() => {}}>
    <div className="w-full h-full p-[22px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>Edit Employee Group</div>
            </div>  
            <div>Manager Group Policy</div>
            <form onSubmit={submitForm}>
            <div className="mb-[2rem]">
              <Input type="text" label="First Name" placeholder="Enter Employee First Name" required={true} value={form.firstName} onChange={(e) => setForm({...form, firstName: e.target.value})} inputClass="capitalize" />
              <SelectInput label="Salary Withdrawal Scheme" value={form.payGroup} onChange={(e) => setForm({...form, payGroup: e.target.value})}>
                            <option value="">Select Group</option>
                            {/* <option value="general-group">General Group</option> */}
                            {[]?.map(group => (
                                <option key={group._id} value={group._id}>{group.name}</option>
                            ))}
              </SelectInput>
              <SelectInput label="Group Salary Withdrawal Limit" value={form.payGroup} onChange={(e) => setForm({...form, payGroup: e.target.value})}>
                            <option value="">Select Group</option>
                            {/* <option value="general-group">General Group</option> */}
                            {[]?.map(group => (
                                <option key={group._id} value={group._id}>{group.name}</option>
                            ))}
              </SelectInput>
           </div>
        <div className="mt-4 flex">
          <ButtonLoader type="submit" loading={getAllGroupsLoading} className="border btn hover:btn-ep-primary w-full">
              <AddIcon /> <span className="text-[#00535C]">Add Employees to Group</span>
          </ButtonLoader>
        </div>
          <div className="bg-[#FFFFFF] flex rounded-lg py-4 mt-4 sm:flex-wrap sm:gap-x-6">
            {
              employees.map((employee, index) => {
                return (
              <div key={index} className="flex justify-between items-center border-dotted border-2 border-[#718096] p-2 bg-[#E5E7EB] rounded-lg">
                {employee.name} <RedXIcon />
              </div>
                )
              })
            }
          </div>
          
          <div className="mt-4 flex justify-end space-x-4">
          <button type="button" onClick={() => setIsEditEmployeeGroupOpen((prevState => !prevState))} className="btn btn-transparent-primary">
              Cancel
          </button>
          <ButtonLoader type="submit" loading={false} className="btn btn-ep-primary">
              Save
          </ButtonLoader>
        </div>
      </form>
    </div>
</WideViewModal>
  )
 }
 
 export const EmployeeActionModal = (props) => {
  const {isOpen, setIsOpen, title, question, actionType, action } = props;

  return (
    <WideViewModal isOpen={isOpen} zIndex="z-[9999]"  wideViewControl={true} size={"xs"} wideViewClassName="w-[30%]" setIsOpen={() => {}}>
      <div className="p-4">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left mb-[24px] flex justify-between">
                <div>{title}</div>
                <div onClick={() => setIsOpen(false)}><CloseOutIcon /></div>
            </div>
            {
              actionType === "delete" && (
                <div>delete</div>
              )
            }
            <div className="mt-6 font-dm-sans text-[#343A40]">
                {question}
            </div>

              <div className={`mt-8 flex justify-between gap-2 w-full ${actionType === "positive" ? "flex-row-reverse": ""}`}>
                  <button type="submit" onClick={action} className={`w-full btn ${actionType === "positive" ? "btn-ep-primary" : "btn-ep-red"}`} autoFocus={true}>
                      Yes
                  </button>
                  <button type="button" className="w-full btn btn-transparent-primary" onClick={() => setIsOpen(!isOpen)}>
                       No
                  </button>
              </div>
      </div>
    </WideViewModal>
  )
}
